import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { InformNotificationPopupProps as Props } from './types';

export const InformNotificationPopup = memo(
  ({ className, children, disabled }: Props) => {
    return (
      <Tooltip
        className={classnames('InformNotificationPopup', className)}
        arrow
        placement="top"
        title={children}
      >
        <Icon
          size={18}
          name="info-circle-outline"
          color={disabled ? 'grey.400' : 'grey.500'}
          sxx={SX.icon(disabled)}
        />
      </Tooltip>
    );
  }
);

InformNotificationPopup.displayName = 'InformNotificationPopup';
